import type { ComponentProps } from "react"
import { AlertDialogTrigger as AlertDialogTriggerBase } from "./base/AlertDialogBase"

export type AlertDialogTriggerProps = ComponentProps<
  typeof AlertDialogTriggerBase
>

function AlertDialogTrigger(props: AlertDialogTriggerProps) {
  return <AlertDialogTriggerBase {...props} />
}

export default AlertDialogTrigger
